/**
 * WP-12 optional CRT-shader overlay (a loving-homage scanline + vignette filter).
 * A single full-viewport, pointer-events-none layer toggled by `applyCrt`. Off by
 * default (see save.ts getCrt) so screenshot goldens — which boot with fresh
 * localStorage — never see it.
 */
const CSS = `
#ar-crt { position: fixed; inset: 0; z-index: 9000; pointer-events: none; display: none; }
#ar-crt.on { display: block; }
#ar-crt::before { content: ''; position: absolute; inset: 0;
  background: repeating-linear-gradient(0deg, hsla(0, 0%, 0%, 0.22) 0px, hsla(0, 0%, 0%, 0.22) 1px, transparent 1px, transparent 3px); }
#ar-crt::after { content: ''; position: absolute; inset: 0;
  background: radial-gradient(ellipse at center, hsla(0, 0%, 0%, 0) 55%, hsla(0, 0%, 0%, 0.38) 100%);
  box-shadow: inset 0 0 120px hsla(0, 0%, 0%, 0.45); }
`;

let overlay: HTMLElement | null = null;

/** Toggle the CRT overlay (creating it on first use). */
export function applyCrt(on: boolean): void {
  if (!document.getElementById('ar-crt-style')) {
    const style = document.createElement('style');
    style.id = 'ar-crt-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'ar-crt';
    document.body.appendChild(overlay);
  }
  overlay.classList.toggle('on', on);
}
